export { NoFAQ } from './index.pc'
export { MobileNoFAQ } from './index.mobile'
